var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.803,
    height: 12.803,
    viewBox: "0 0 8.803 8.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M10.483,24.521H4.32A1.322,1.322,0,0,1,3,23.2V21.44a.44.44,0,0,1,.88,0V23.2a.441.441,0,0,0,.44.44h6.162a.441.441,0,0,0,.44-.44V21.44a.44.44,0,0,1,.88,0V23.2A1.322,1.322,0,0,1,10.483,24.521Z",
    transform: "translate(-3 -15.718)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M11.641,16.581a.439.439,0,0,1-.311-.129l-2.2-2.2a.44.44,0,0,1,.622-.622l1.89,1.89,1.89-1.89a.44.44,0,0,1,.622.622l-2.2,2.2A.439.439,0,0,1,11.641,16.581Z",
    transform: "translate(-7.239 -10.419)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M16.94,9.162a.44.44,0,0,1-.44-.44V3.44a.44.44,0,1,1,.88,0V8.722A.44.44,0,0,1,16.94,9.162Z",
    transform: "translate(-12.539 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.489a64337aa3d3a6a74713c31323ccd4.svg";
export { ForwardRef as ReactComponent };